module.exports = __webpack_public_path__ + "img/img13.e68b3290.svg";